/**
 * Movement constants - browser-safe, zero imports.
 * This is the foundation file that other movement files build upon.
 */
// const movementCategoryEnum = ['strength', 'cardio', 'functional', 'isometric', 'flexibility', 'mobility', 'plyometric', 'recovery', 'other'] as const;
// type MovementCategory = (typeof movementCategoryEnum)[number];
// Their `label` (what is shown to the user) will be defined in the UI (i18n section)
const movementTypes = {
    ISOLATION: 'isolation',
    COMPOUND: 'compound',
};
export { movementTypes };
//# sourceMappingURL=movement.constants.js.map